/* MTC UX Optimization (draft) — lightweight, dependency-free helpers */
(function () {
  'use strict';
  var cfg = window.MTC_UX = window.MTC_UX || {};

  /* ---------- Money formatting (mirrors Shopify money format) ---------- */
  function fmtNum(cents, decimals, thou, dec) {
    var n = (cents / 100).toFixed(decimals);
    var parts = n.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thou);
    return parts[1] ? whole + dec + parts[1] : whole;
  }
  function formatMoney(cents) {
    var f = cfg.moneyFormat || '{{amount}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return fmtNum(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmtNum(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmtNum(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmtNum(cents, 2, "'", '.');
        case 'amount_with_period_and_space': return fmtNum(cents, 2, ' ', '.');
        case 'amount_no_decimals_with_space_separator': return fmtNum(cents, 0, ' ', '.');
        case 'amount_with_space_separator': return fmtNum(cents, 2, ' ', ',');
        default: return fmtNum(cents, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }
  window.MTC_UX.formatMoney = formatMoney;

  /* ---------- Cart state: sticky mobile cart + free delivery progress ---------- */
  function cartUrl() { return (window.routes && window.routes.cart_url) || '/cart'; }
  function updateCartBar(cart) {
    var bar = document.getElementById('MtcCartBar');
    if (!bar) return;
    var c = cart.item_count;
    bar.classList.toggle('is-empty', c === 0);
    document.body.classList.toggle('mtc-has-cartbar', c > 0);
    var cnt = bar.querySelector('[data-mtc-count]');
    if (cnt) cnt.textContent = c + (c === 1 ? ' item' : ' items');
    var tot = bar.querySelector('[data-mtc-total]');
    if (tot) tot.textContent = formatMoney(cart.total_price);
  }
  function updateFreeship(cart) {
    var th = cfg.freeShippingThreshold;
    if (!th) return;
    document.querySelectorAll('[data-mtc-freeship]').forEach(function (el) {
      if (!cart.item_count) { el.hidden = true; return; }
      el.hidden = false;
      var total = cart.total_price;
      var remaining = th - total;
      var pct = Math.max(4, Math.min(100, Math.round((total / th) * 100)));
      var msg = el.querySelector('.mtc-freeship__msg');
      var ar = el.querySelector('.mtc-freeship__ar');
      var fill = el.querySelector('.mtc-freeship__fill');
      if (remaining > 0) {
        el.classList.remove('is-done');
        msg.innerHTML = 'Add <strong>' + formatMoney(remaining) + '</strong> more to get <strong>FREE DELIVERY</strong>';
        ar.innerHTML = '\u0623\u0636\u0641 <bdi dir="ltr">' + formatMoney(remaining) + '</bdi> \u0644\u0644\u062d\u0635\u0648\u0644 \u0639\u0644\u0649 \u062a\u0648\u0635\u064a\u0644 \u0645\u062c\u0627\u0646\u064a';
      } else {
        el.classList.add('is-done');
        msg.innerHTML = '<strong>Your order qualifies for FREE DELIVERY</strong>';
        ar.textContent = '\u0637\u0644\u0628\u0643 \u0645\u0624\u0647\u0644 \u0644\u0644\u062a\u0648\u0635\u064a\u0644 \u0627\u0644\u0645\u062c\u0627\u0646\u064a';
      }
      if (fill) fill.style.width = pct + '%';
    });
  }
  var pending = null;
  function refresh() {
    if (pending) return pending;
    pending = fetch(cartUrl() + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartBar(cart); updateFreeship(cart); return cart; })
      .catch(function () {})
      .then(function (c) { pending = null; return c; });
    return pending;
  }
  window.MTC_UX.refreshCart = refresh;

  /* Refresh after any cart mutation (theme product forms, quick add, cart page, apps). */
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function () { setTimeout(refresh, 200); }, function () {});
      }
      return p;
    };
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  /* ---------- Quantity stepper on quick-add product cards ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mtc-step]');
    if (!b) return;
    e.preventDefault();
    var input = b.parentElement.querySelector('.mtc-qty__input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, v + parseInt(b.getAttribute('data-mtc-step'), 10));
  });
  document.addEventListener('change', function (e) {
    if (!e.target.classList || !e.target.classList.contains('mtc-qty__input')) return;
    var v = parseInt(e.target.value, 10);
    if (!v || v < 1) e.target.value = 1;
  });

  /* ---------- Recently viewed (localStorage only, no extra requests) ---------- */
  var RV_KEY = 'mtc_recently_viewed_v1';
  function rvGet() { try { return JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (e) { return []; } }
  function rvSave(list) { try { localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12))); } catch (e) {} }
  var current = null;
  var curEl = document.querySelector('script[data-mtc-current-product]');
  if (curEl) { try { current = JSON.parse(curEl.textContent); } catch (e) { current = null; } }

  function tile(p) {
    var li = document.createElement('li'); li.className = 'mtc-rv__item';
    var a = document.createElement('a'); a.href = p.url;
    var box = document.createElement('div'); box.className = 'mtc-rv__img';
    if (p.image) { var img = document.createElement('img'); img.src = p.image; img.alt = p.title; img.loading = 'lazy'; img.width = 300; img.height = 300; box.appendChild(img); }
    var t = document.createElement('div'); t.className = 'mtc-rv__t'; t.textContent = p.title;
    a.appendChild(box); a.appendChild(t);
    if (p.price) { var pr = document.createElement('div'); pr.className = 'mtc-rv__p'; pr.textContent = p.price; a.appendChild(pr); }
    li.appendChild(a); return li;
  }
  document.querySelectorAll('[data-mtc-rv]').forEach(function (sec) {
    var limit = parseInt(sec.getAttribute('data-limit') || '6', 10);
    var list = rvGet().filter(function (p) { return !current || p.handle !== current.handle; }).slice(0, limit);
    if (!list.length) return;
    var ul = sec.querySelector('.mtc-rv__list');
    list.forEach(function (p) { ul.appendChild(tile(p)); });
    sec.hidden = false;
  });
  if (current && current.handle) {
    var l = rvGet().filter(function (p) { return p.handle !== current.handle; });
    l.unshift(current); rvSave(l);
  }

  /* ---------- Cart: "You may also need" via Shopify product recommendations ---------- */
  document.querySelectorAll('[data-mtc-suggest]').forEach(function (sec) {
    var pid = sec.getAttribute('data-product-id');
    if (!pid) return;
    var inCart = (sec.getAttribute('data-in-cart') || '').split(',');
    var base = (window.routes && window.routes.product_recommendations_url) || '/recommendations/products';
    fetch(base + '.json?product_id=' + encodeURIComponent(pid) + '&limit=10&intent=related')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        var items = (data.products || []).filter(function (p) { return p.available && inCart.indexOf(String(p.id)) === -1; }).slice(0, 4);
        if (!items.length) return;
        var ul = sec.querySelector('.mtc-rv__list');
        items.forEach(function (p) {
          var img = p.featured_image ? (p.featured_image.indexOf('?') > -1 ? p.featured_image + '&width=300' : p.featured_image + '?width=300') : '';
          ul.appendChild(tile({ url: p.url, title: p.title, image: img, price: formatMoney(p.price) }));
        });
        sec.hidden = false;
      })
      .catch(function () {});
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
})();
